import {NgModule} from '@angular/core';
import {MilitaryExperienceService} from './military-experience.service';

/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
@NgModule({
    providers: [
        MilitaryExperienceService
    ]
})
export class MilitaryExperienceModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/work/military/military-experience.module.ts